/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui-persistent-notification{display:flex;align-items:center;border-radius:4px;padding:10px;width:calc(100% - 20px)}.ui-persistent-notification-container{position:fixed;bottom:20px;right:20px;z-index:4000;max-width:35em}.ui-persistent-notification-message{padding-left:10px}.ui-persistent-notification-actions{display:flex}"];
export { styles as styles };
